
import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbConfigIntegrador extends AppService {
  abstract getTimeZones(config: string): Observable<any>;
  abstract getConfigIntegrador(id: number): Observable<any>;
  abstract getConfiguracaoMfa(): Observable<any>;
  abstract getTenantsDisponiveis(): Observable<any>;
  abstract saveConfiguracaoMfaContas(habilitarMFAIntegradores: boolean, habilitarMFAContas: boolean, contasAtivacaoMFA: number[]): Observable<any>;
  abstract atualizarMfa(integradorId: number, habilitar: boolean): Observable<any>;
  abstract salvaCofigIntegrador(config: any);
}
